import { useQuery, UseQueryResult } from 'react-query'
import fetchEgift, { TEgiftInfoResponse } from '@/src/common/queries/FetchEgift'

const retryCount = 30

const useFetchEgift = (uuid: string): UseQueryResult<TEgiftInfoResponse> => {
    return useQuery(
        ['fetchEgift', uuid],
        () => {
            return fetchEgift(uuid)
        },
        {
            // retry 30 times if the response fails - equivalent to 1 minute
            retry: retryCount,
            refetchInterval: (
                response: TEgiftInfoResponse | undefined,
                query
            ) => {
                if (query.state.dataUpdateCount > retryCount) {
                    console.log(
                        'retry count too high, stopping fetch',
                        query.state.dataUpdateCount
                    )
                    return false
                }

                // continue retrying if the status is not one of these
                return ['fulfilled', 'active', 'error'].includes(
                    String(response?.data?.status)
                )
                    ? false
                    : 2000
            },
        }
    )
}

export default useFetchEgift
